import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
// import MainPage from '@/components/MainPage'

const Login = r => require.ensure([], () => r(require('@/components/Login')), 'Login')
const LoginSSO = r => require.ensure([], () => r(require('@/components/LoginSSO')), 'LoginSSO')
const ImageUpload = r => require.ensure([], () => r(require('@/components/image/ImageUpload')), 'ImageUpload')
const MainPage = r => require.ensure([], () => r(require('@/components/MainPage')), 'MainPage')
const UserList = r => require.ensure([], () => r(require('@/components/user/UserList')), 'UserList')
const UserEdit = r => require.ensure([], () => r(require('@/components/user/UserEdit')), 'UserEdit')
const UserRoleEdit = r => require.ensure([], () => r(require('@/components/user/UserRoleEdit')), 'UserRoleEdit')
const RoleList = r => require.ensure([], () => r(require('@/components/user/RoleList')), 'RoleList')
const ModifyPwd = r => require.ensure([], () => r(require('@/components/user/ModifyPwd')), 'ModifyPwd')
const ModifyInfo = r => require.ensure([], () => r(require('@/components/user/ModifyInfo')), 'ModifyInfo')

const CompanyInfo = r => require.ensure([], () => r(require('@/components/company/CompanyInfo')), 'CompanyInfo')
const CompanyEdit = r => require.ensure([], () => r(require('@/components/company/CompanyEdit')), 'CompanyEdit')
const NeedAuth = r => require.ensure([], () => r(require('@/components/company/NeedAuth')), 'NeedAuth')

const StaffList = r => require.ensure([], () => r(require('@/components/staff/StaffList')), 'StaffList')
const StaffEdit = r => require.ensure([], () => r(require('@/components/staff/StaffEdit')), 'StaffEdit')
const StaffImport = r => require.ensure([], () => r(require('@/components/staff/StaffImport')), 'StaffImport')
const StaffDetail = r => require.ensure([], () => r(require('@/components/staff/StaffDetail')), 'StaffDetail')

const ConsumeReport = r => require.ensure([], () => r(require('@/components/consume/ConsumeReport')), 'ConsumeReport')

const SystemLogList = r => require.ensure([], () => r(require('@/components/system/SystemLogList')), 'SystemLogList')
const UserCenter = r => require.ensure([], () => r(require('@/components/system/UserCenter')), 'UserCenter')

const WorkingTable = r => require.ensure([], () => r(require('@/components/work/WorkingTable')), 'WorkingTable')


Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: Login
    // },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/LoginSSO',
      name: 'LoginSSO',
      component: LoginSSO
    },
    {
      path: '/ImageUpload',
      name: 'ImageUpload',
      component: ImageUpload
    },
    {
        path: '/MainPage',
        name: 'MainPage',
        component: MainPage,
        children: [
            {
                path: '/WorkingTable',
                name: 'WorkingTable',
                component: WorkingTable
            },
            {
                path: '/UserList',
                name: 'UserList',
                component: UserList
            },
            {
                path: '/UserEdit',
                name: 'UserEdit',
                component: UserEdit
            },
            {
                path: '/UserRoleEdit',
                name: 'UserRoleEdit',
                component: UserRoleEdit
            },
            {
                path: '/RoleList',
                name: 'RoleList',
                component: RoleList
            },
            {
                path: '/CompanyInfo',
                name: 'CompanyInfo',
                component: CompanyInfo
            },
            {
                path: '/NeedAuth',
                name: 'NeedAuth',
                component: NeedAuth
            },
            {
                path: '/CompanyEdit',
                name: 'CompanyEdit',
                component: CompanyEdit
            },
            {
                path: '/StaffList',
                name: 'StaffList',
                component: StaffList
            },
            {
                path: '/StaffEdit',
                name: 'StaffEdit',
                component: StaffEdit
            },
            {
                path: '/StaffImport',
                name: 'StaffImport',
                component: StaffImport
            },
            {
                path: '/StaffDetail',
                name: 'StaffDetail',
                component: StaffDetail
            },
            {
                path: '/ConsumeReport',
                name: 'ConsumeReport',
                component: ConsumeReport
            },
            {
                path: '/SystemLogList',
                name: 'SystemLogList',
                component: SystemLogList
            },
            {
                path: '/UserCenter',
                name: 'UserCenter',
                component: UserCenter
            },

        ]
    },
    {
        path: '/ModifyPwd',
        name: 'ModifyPwd',
        component: ModifyPwd
    },
    {
        path: '/ModifyInfo',
        name: 'ModifyInfo',
        component: ModifyInfo
    },
    // {
    //     path: '/CompanyEdit',
    //     name: 'CompanyEdit',
    //     components: {
    //         default: MainPage,
    //         mainpage: CompanyEdit
    //     }
    // },
    // {
    //     path: '/CompanyList',
    //     name: 'CompanyList',
    //     component: CompanyList
    // },
    // {
    //     path: '/CompanyEdit',
    //     name: 'CompanyEdit',
    //     component: CompanyEdit
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js